export const ColorDictionary = {
  Black: "#000000",
  White: "#FFFFFF",
  "Rose Gold": "#B76E79",
  Gold: "#FFD700",
  Silver: "#C0C0C0",
  Bronze: "#CD7F32",
  Copper: "#B87333",
  Platinum: "#E5E4E2",
  Nickel: "#708090",
  Burgundy: "#800020",
  Ivory: "#FFFFF0",
  Jade: "#00A86B",
};
